import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import {
  AppSearchSelect,
  AppInput,
  AppSearchSectionSelect,
} from "../../components/appComponents";
import { useNavigate } from "react-router-dom";
import {
  BookingStatusEnum,
  PaymentStatusEnum,
  AmenityTypeEnum,
  DateminFormat,
  respEnum,
} from "../../constants/appConstant";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import moment from "moment";

const AmenityBookings = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [clubamenityId, setclubAmenityId] = useState(null);
  const [playerId, setPlayerId] = useState(null);
  const [bookingStatus, setBookingStatus] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [tillDate, setTillDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [amenityList, setAmenityList] = useState([]);
  const [playerList, setPlayerList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getData(1);
    getAmenities();
    getPlayers();
  }, []);

  useEffect(() => {
    getData(1);
  }, [
    clubamenityId,
    playerId,
    bookingStatus,
    paymentStatus,
    fromDate,
    tillDate,
  ]);

  const resetFilters = () => {
    setclubAmenityId(null);
    setPlayerId(null);
    setBookingStatus(null);
    setPaymentStatus(null);
    setFromDate(null);
    setTillDate(null);
    setSearchTerm(null);
  };

  const _bookingStatuses = [
    { id: null, name: "All Status" },
    { id: BookingStatusEnum.Booked, name: "Booked" },
    { id: BookingStatusEnum.Cancelled_By_Club, name: "Cancelled By Club" },
  ];

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    try {
      debugger;
      setIsLoading(true);
      const response = await Common.ApiService.getInstance().request(
        "GetAmenityBookings",
        {
          pageNumber: pageNumber,
          q: searchTerm,
          recordsToDisplay,
          clubamenityId: clubamenityId?.value || null,
          playerId: playerId,
          bookingstatus: bookingStatus,
          paymentstatus: paymentStatus,
          fromDate: fromDate,
          tillDate: tillDate,
        },
        "Post"
      );

      if (response?.data && response.data.length > 0) {
        let obj = {
          ...response.data[0],
          data: response.data[0].data.map((item) => ({
            ...item,
            bookingdate: item.bookingdate
              ? Common.Utility.ConvertTime(item.bookingdate, DateminFormat)
              : null,
            startdatetime: item.startdatetime
              ? Common.Utility.ConvertTime(item.startdatetime)
              : null,
            enddatetime: item.enddatetime
              ? Common.Utility.ConvertTime(item.enddatetime)
              : null,
            createdon: item.createdon
              ? Common.Utility.ConvertTime(item.createdon)
              : null,
          })),
        };
        setData(obj);
      } else {
        setData({ data: [], totalRecords: 0 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching booking data");
      setData({ data: [], totalRecords: 0 });
    } finally {
      setIsLoading(false);
    }
  };

  const getAmenities = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetAmenityWiseFacilitiesddl",
        {},
        "Get",
        false
      );
      if (response?.data) {
        setAmenityList(response.data);
      }
    } catch (error) {
      console.error("Error fetching amenities:", error);
    }
  };

  const getPlayers = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "ClubPlayersddl",
        {},
        "Get",
        false
      );
      const data = [
        { id: null, name: "All Customers" },
        ...(response?.data ?? []),
      ];
      setPlayerList(data);
    } catch (error) {
      console.error("Error fetching players:", error);
    }
  };

  const handleViewDetails = (id) => {
    navigate(`/app/amenitybookingdetails?id=${id}`);
  };

  const handleDeleteBooking = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0C1B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await Common.ApiService.getInstance().request(
          `DeleteAmenityBooking?id=${id}`,
          {},
          "Delete"
        );

        if (response?.status === respEnum.Success) {
          toast.success("Booking deleted successfully");
          getData(1);
        } else {
          toast.error(response?.message || "Error deleting booking");
        }
      } catch (error) {
        console.error("Error deleting booking:", error);
        toast.error("Error deleting booking");
      }
    }
  };

  const getBookingStatusLabel = (status) => {
    debugger;
    switch (status) {
      case BookingStatusEnum.Booked:
        return (
          <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
            Booked
          </span>
        );
      case BookingStatusEnum.Cancelled_By_Club:
        return (
          <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium">
            Cancelled
          </span>
        );

      default:
        return (
          <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs font-medium">
            Unknown
          </span>
        );
    }
  };

  const getPaymentStatusLabel = (status) => {
    switch (status) {
      case PaymentStatusEnum.Paid:
        return (
          <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
            Paid
          </span>
        );
      case PaymentStatusEnum.Un_Paid:
        return (
          <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium">
            Unpaid
          </span>
        );
      case PaymentStatusEnum.Partial_Paid:
        return (
          <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
            Partial
          </span>
        );
      default:
        return (
          <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs font-medium">
            Unknown
          </span>
        );
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case AmenityTypeEnum.Session_Based:
        return (
          <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
            Session Based
          </span>
        );
      case AmenityTypeEnum.Package_Based:
        return (
          <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-medium">
            Package Based
          </span>
        );
      default:
        return (
          <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs font-medium">
            Unknown
          </span>
        );
    }
  };

  const actions = [
    {
      type: "view",
      onClick: (val) => handleViewDetails(val.id),
      icon: "heroicons:eye",
      color: "text-blue-600",
      tooltip: "View Details",
    },
    // {
    //   type: "delete",
    //   onClick: (val) => handleDeleteBooking(val.id),
    //   icon: "heroicons:trash",
    //   color: "text-red-600",
    //   tooltip: "Delete Booking",
    // },
  ];

  const _thead = [
    { title: "ID", type: "number", isVisible: false, key: "id" },
    {
      title: "Ref Number",
      type: "text",
      isVisible: true,
      key: "refno",
      render: (row) => (
        <span className="font-medium text-[#0C1B3A]">{row.refno}</span>
      ),
    },
    {
      title: "Customer",
      type: "text",
      isVisible: true,
      key: "playerName",
      render: (row) => (
        <span className="text-gray-700">
          {row.playerName || "Not specified"}
        </span>
      ),
    },
    {
      title: "Facility",
      type: "text",
      isVisible: true,
      key: "amenityName",
      render: (row) => (
        <span className="text-gray-700">
          {row.clubamenityName + " (" + row.amenityName + ")" ||
            "Not specified"}
        </span>
      ),
    },
    {
      title: "Type",
      type: "text",
      isVisible: true,
      key: "type",
      render: (row) => getTypeLabel(row.type),
    },
    {
      title: "Booking Date",
      type: "text",
      isVisible: true,
      key: "bookingdate",
      render: (row) => (
        <span className="text-gray-700">
          {row.bookingdate
            ? moment(row.bookingdate).format("DD MMM YYYY")
            : "Not specified"}
        </span>
      ),
    },
    {
      title: "Persons",
      type: "number",
      isVisible: true,
      key: "noofpersons",
      render: (row) => <span className="text-gray-700">{row.noofpersons}</span>,
    },
    {
      title: "Total",
      type: "number",
      isVisible: true,
      key: "total",
      render: (row) => (
        <span className="font-medium text-[#0C1B3A]">
          {row.total ? row.total.toFixed(2) : "0.00"}
        </span>
      ),
    },
    {
      title: "Payment Status",
      type: "text",
      isVisible: true,
      key: "paymentstatus",
      render: (row) => getPaymentStatusLabel(row.paymentstatus),
    },
    {
      title: "Status",
      type: "text",
      isVisible: true,
      key: "bookingstatus",
      render: (row) => getBookingStatusLabel(row.bookingstatus),
    },
    {
      title: "Created On",
      type: "text",
      isVisible: true,
      key: "createdon",
      render: (row) => (
        <span className="text-gray-600 text-xs">
          {row.createdon
            ? moment(row.createdon).format("DD MMM YYYY")
            : "Not specified"}
        </span>
      ),
    },
  ];

  const renderFilters = () => (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
      <AppSearchSectionSelect
        value={clubamenityId}
        onChange={setclubAmenityId}
        placeholder="Filter by Facility"
        data={amenityList}
        className="mb-0"
      />
      <AppSearchSelect
        value={playerId}
        onChange={setPlayerId}
        placeholder="Filter by Customer"
        data={playerList}
        className="mb-0"
      />
      <AppSearchSelect
        value={bookingStatus}
        onChange={setBookingStatus}
        placeholder="Filter by Status"
        data={_bookingStatuses}
        className="mb-0"
      />
      <AppSearchSelect
        value={paymentStatus}
        onChange={setPaymentStatus}
        placeholder="Filter by Payment"
        data={[
          { id: null, name: "All Payments" },
          ...Common.Utility.enumToArray(PaymentStatusEnum),
        ]}
        className="mb-0"
      />
      {/* <AppInput
        type="date"
        value={fromDate}
        onChange={setFromDate}
        placeholder="From Date"
        className="mb-0"
      />
      <AppInput
        type="date"
        value={tillDate}
        onChange={setTillDate}
        placeholder="Till Date"
        className="mb-0"
      /> */}
      <div className="flex gap-2">
        <Button
          onClick={resetFilters}
          variant="outline"
          className="border-[#0C1B3A] text-[#0C1B3A] hover:bg-[#e8eaf0] flex-1"
        >
          <Icon icon="heroicons:x-mark" className="mr-1" />
          Reset
        </Button>
      </div>
    </div>
  );

  const addButton = () => (
    <Button
      onClick={() => navigate("/app/addamenitybooking")}
      className="bg-[#0C1B3A] hover:bg-[#1a2a4e] text-white border-0"
    >
      <Icon icon="heroicons:plus" className="mr-1" />
      Add Facility Booking
    </Button>
  );

  return (
    <div className="container mx-auto p-3">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold text-[#0C1B3A] flex items-center">
          <Icon icon="heroicons:building-office" className="mr-2" />
          Facility Bookings
        </h1>
        {addButton()}
      </div>

      {renderFilters()}

      <AdvanceTable
        title="Facility Bookings"
        columns={_thead.filter((item) => item.isVisible)}
        data={data}
        getData={getData}
        showPagination={true}
        showAddButton={false}
        actionButtons={actions}
        isLoading={isLoading}
        showSearch={true}
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      />
    </div>
  );
};

export default AmenityBookings;
